import { useTextes } from '@common/config';
import { SIREN_REGEX } from '@common/schemas';
import { z } from 'zod';

const t = useTextes('Inscription', 'RenseignementSiren');

export const searchBySirenSchema = z.object({
  siren: z.string()
    .regex(SIREN_REGEX, { error: t['SIREN_MES1'] }),
});

export type SearchBySirenResult = z.infer<typeof searchBySirenSchema>